import { WithStyles, withStyles } from '@mui/styles';
import { ClientMessageRecordExtended } from '@tassat/fred-extended-definitions';

import { ClientMessageDetails } from './clientMessageDetails';
import { muiStyles } from './styles';

export interface ClientMessageDetailsProps extends WithStyles<typeof muiStyles> {
    selectedMessage: ClientMessageRecordExtended;
    confirmApprove: () => void;
    confirmDecline: () => void;
}

export default withStyles(muiStyles)(ClientMessageDetails);